import React from 'react'
import Navbar from '../../common/Navbar'
import Banner from './Banner'

function Header() {
	return (
		<div>
			<Navbar />
			<Banner />
		</div>
	)
}

export default Header
